const pad = (n) => String(n).padStart(2, '0');

export const toDatetimeLocalValue = (date = new Date()) => {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const defaultCustomValidityLocal = (daysAhead = 7) =>
  toDatetimeLocalValue(new Date(Date.now() + daysAhead * 24 * 60 * 60 * 1000));

export const buildInviteValidityPayload = ({
  showValidityOptions,
  validityMode,
  validityPreset,
  validityCustomUntil,
}) => {
  if (!showValidityOptions) {
    return { payload: { validity: { mode: 'never' } } };
  }

  if (validityMode === 'preset') {
    return { payload: { validity: { mode: 'preset', preset: validityPreset } } };
  }

  if (validityMode === 'never') {
    return { payload: { validity: { mode: 'never' } } };
  }

  if (validityMode === 'custom') {
    const raw = String(validityCustomUntil || '').trim();
    if (!raw) {
      return { error: 'Select a future date and time for the invite code.' };
    }

    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) {
      return { error: 'Invalid custom validity date/time.' };
    }

    if (parsed.getTime() <= Date.now()) {
      return { error: 'Custom validity must be a future date/time.' };
    }

    return {
      payload: {
        validity: {
          mode: 'custom',
          customUntil: parsed.toISOString(),
        },
      },
    };
  }

  return { payload: { validity: { mode: 'never' } } };
};
